// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-extra-large';

export const Component = () => (
  <g fill='none' stroke='transparent' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='#D0E0F7' d='M2 16C2 8.489 8.489 2 16 2h2v16H2v-2Z' />
    <path
      fill='#4185DE'
      d='M1 16C1 7.944 7.944 1 16 1h2v2h-2C8.925 3 3 8.925 3 16H1Zm17 2H2h16ZM1 18v-2C1 7.944 7.944 1 16 1v2C8.925 3 3 8.925 3 16v2H1ZM18 2v16V2Z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
